/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RedeemStatus {
  UNAVAILABLE = 'UNAVAILABLE',
  AVAILABLE = 'AVAILABLE',
  MFA_REQUIRED = 'MFA_REQUIRED',
  SSO_REQUIRED = 'SSO_REQUIRED'
}
